import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
import { ExcelServicesService } from '../../Shared/Service/excel-services';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: Date;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-mapping-details',
  templateUrl: './mapping-details.component.html',
  styleUrls: ['./mapping-details.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class MappingDetailsComponent implements OnInit {

  today = new Date();
  today1 = new Date();
  Val: string;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  displayedColumns = ["sourceRoot",
    "sourceEelement",
    "targetRoot",
    "tagetElement",
    "elementType",
    "sampleValues",
    "remarks",
    "mandatory",
    "dataType",
    "width",
    "createdBy",
    "createdatetime"];
  apiresult: any
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  selectedDateStore: any;
  selectedTOODateStore: any;
  filterProperty: any;
  XMLName: any;
  defaultData: any;
  status: void;
  btnDisabled: boolean = true;
  providerListSelected: any;
  payloadListSelected: any
  PayloadFilterRes: any;
  requestPayload: any
  providerList = []
  searchBarFilter: boolean = false;
  EnableDisableExcel: boolean = false;
  constructor(private datePipe: DatePipe,private apiCallIdsService: DashboarduiService, private toastr: ToastrService,private excelService: ExcelServicesService) {

  }

  display: Boolean = false;
  selectedDate: any = new Date(this.today.setDate(this.today.getDate()));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate()));
  isProgressing: Boolean = false;
  Userid: any = [];
  search: string;
  totalcount: any = 0;
  statusResult: string;
  CurrentDate = new Date();

  ngOnInit() {

    this.isProgressing = true;
    this.callProviderListAPI()
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.errorMsgSubscription = true
    this.statusResult = "Mapped"
    this.errorMessage = "Please select provider,payload and click load"
    // this.providerList = []
    this.displayContent = false
  }
  callProviderListAPI() {
    this.apiCallIdsService.GetProvideList()
      .subscribe((data) => {
        console.log('response =', data);
        this.apiresult = data
        this.PayloadFilterRes = this.apiresult.payloadList
        console.log('providerList ==',this.PayloadFilterRes)
        // console.log('payloadList =', data.payloadList + '&& providerList'+ data.providerList);
        this.isProgressing = false;
      });
  }


  changeProviderList(data: any) {
    if(data){
      this.btnDisabled = false
    }
    
  }
  changePayloadList(data: any) {
    console.log("changeProviderList selected --->" + data);
    this.payloadListSelected = data
    // this.providerListSelected = data;
    this.isProgressing = true;
    this.providerList = this.apiresult.providerList.filter(obj => obj.payloadType == data);
    console.log('Filter Result === ', this.providerList);
    this.isProgressing = false;
  }
  

  GetLoadMethodIDSUser() {
    this.isProgressing = true;
    this.Val = '';
    this.requestPayload = {
      "Provider": this.providerListSelected,
      "Payload": this.payloadListSelected,
      "Flag": this.statusResult,
    }
    console.log('Request Payload = ', this.requestPayload)
    this.apiCallIdsService.ReadFXEinvoiceMappedDetails(this.requestPayload)
      .subscribe((data) => {
        console.log('response =', data);
        if (data.length < 1) {
          this.searchBarFilter = false
          this.displayContent = false
          this.errorMsgSubscription = true
          this.errorMessage = "No Data Found"
          this.toastr.error('No Data Found');
          this.isProgressing = false;
        }
        else {
          this.searchBarFilter = true
          this.errorMsgSubscription = false
          this.displayContent = true
          this.EnableDisableExcel = true
          this.idsProductList = data;
          this.filterProperty = this.idsProductList
          this.dataSource = new MatTableDataSource(this.idsProductList);
          // this.dataSource.paginator = this.paginator;
          this.toastr.success('Data loaded Successfully');
          this.isProgressing = false;
        }
      });
  }

  Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { dhElement: { toString: () => string; }; tagetElement: { toString: () => string; } }) => {
      return res.dhElement.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.tagetElement.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
    }
  }


  exportAsXLSX() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
		var filterArray = [];
		var slno = 1;
		const excelTitle = "Mapping Details";
		const excelDownloadTitle = "Mapping Details";
		const title = "Title: " + excelTitle;
		const role = "Role: " + "IDS User";
		const bindFirstName = "EmailId: " + this.Userid;
		const header = ["S.NO","DH Root",
      "DH Element",
      "Target Root",
      "Target Element",
      "Element Type",
      "Sample Values",
      "Remarks",
      "Mandatory",
      "Data Type",
      "Width",
      "Created By",
      "Created Date"];
		for (var i in this.filterProperty) {
			filterArray.push([
				slno, this.filterProperty[i].dhRoot, this.filterProperty[i].dhElement, this.filterProperty[i].targetRoot, this.filterProperty[i].tagetElement,this.filterProperty[i].elementType,this.filterProperty[i].sampleValues, this.filterProperty[i].remarks, this.filterProperty[i].mandatory,this.filterProperty[i].dataType,this.filterProperty[i].width,this.filterProperty[i].createdBy,this.datePipe.transform(this.filterProperty[i].crdt, 'dd-MMM-y, HH:mm')
			])
			slno = slno + 1;
		}

		this.excelService.ExcelForMappingDetails(filterArray, bindFirstName, title, role, header, excelTitle, excelDownloadTitle);
	}
}